import React from 'react';
import Header from './Header';
import Footer from './Footer';
import './layout.css';
import { Outlet } from 'react-router-dom';
import { UserProvider } from '../utils/UserContext';

const Main = () => {
    return (
        <div className="layout-container">
            <UserProvider>
                <Header/>
                <main>
                    <Outlet/>
                </main>
            </UserProvider>
            <Footer/>
        </div>
    );
};

export default Main;
